// extracted by mini-css-extract-plugin
export default {"head":"Categories_head__nX31E","title":"Categories_title__fc8eh","wrapper":"Categories_wrapper__6yktD"};